<template>
  <TransitionRoot appear as="template" :show="isOpen">
    <Dialog as="div" class="relative z-10" @close="close">
      <div class="fixed inset-0" />

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leave-from="translate-x-0"
              leave-to="translate-x-full">
              <DialogPanel class="pointer-events-auto w-screen max-w-md">
                <slot name="form" :close="close" :done="done" />
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, TransitionChild, TransitionRoot, DialogPanel } from "@headlessui/vue"

export default {
  components: {
    Dialog,
    DialogPanel,

    TransitionChild,
    TransitionRoot
  },
  props: {
    defaultSuccessTitle: {
      type: String,
      default: "Success"
    },
    defaultSuccessMsg: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:isOpen", "onSave"],
  data() {
    return {
      show_is_done: false
    }
  },

  methods: {
    done() {
      this.close()
      this.$toast.open({
        message: `${this.defaultSuccessTitle}\n${this.defaultSuccessMsg}`,
        position: "top",
        type: "success",
        duration: 3000
      })
    },
    close() {
      this.$emit("update:isOpen", false)
      setTimeout(() => {
        this.show_is_done = false
      }, 500)
    }
  }
}
</script>
